<template>
    <div id="generalLedgerReport">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> General Ledger Report</div>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportEnrichReports()">
                          <i class="fp-export"></i> Compare
                        </a>
                        <button v-if="canCalculateEarnings" type="submit" title="Recalculate Retained Earnings" class="btn btn-primary" v-on:click.prevent="calculateEquity()">
                            <i class="fp-accounting"></i> Calculate Current R/E
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content general-ledger-report">
                        <data-table-filter-config :moduleName="'generalLedgerReport'" @cancelSelection="cancelAll" :fromDashboard="$route.query.from" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <p v-if="equityBatchProcess" id="equityFetchBatchMsg" class="alert-success p-2">Current batch {{equitybatchNum}} is processing. Please wait while we calculate retained earnings !!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = '';batchProcess = 0">×</button></p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'generalLedgerReport'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="glReport"
                                    mode="remote"
                                    title="General Ledger"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                    enabled: false,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <!-- <div v-if="props.column.field == 'reference'">
                                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                            </div> -->
                                            <div v-if="props.column.field == 'doc_no'">
                                                <template v-if="props.row.doc_no != null && props.row.doc_no != ''">
                                                    <a href="javascript:void(0)" class="color-blue" v-on:click="docLinkCreate(props.row)" title="View Document">{{props.row.doc_no}}</a>
                                                </template>
                                                <template v-else>
                                                    {{props.formattedRow[props.column.field]}}
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../../mixins/commonMixins';
import {contractMixins} from '../../../mixins/contractMixins';
import {dataTableMixins} from '../../../mixins/dataTableMixins';

let msgServer;


export default {
    name: "GeneralLedgerReport",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "General Ledger Report | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        batchProcess:0,
        batchNum:"",
        permissions:[],
        loading:false,
        cantAccessPage:"",
        userColumns:[],
        columns: [
          {
                label:'Comp Nbr',
                field:'comp_nbr',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Date',
                field:'post_date',
                fpFieldType:"custom_date",
                filterable: true,
                hidden:true,
            },
            {
                label:'Src',
                field:'source',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label:'Tran Number',
                field:'transaction_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Asset',
                field:'asset',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
             {
                label:'Seq Nbr',
                field:'seq_nbr',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Tran Line',
                field:'tran_line',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },

            {
                label:'GL Account Number',
                field:'account_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Account Description',
                field:'account_description',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Trans Amount',
                field:'journal_amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                sortable:true
            },
            {
                label:'Trans Description',
                field:'trans_desc',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Document Number',
                field:'doc_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Document Date',
                field: 'doc_dt',
                fpFieldType:"custom_date",
                filterable: true,
                hidden:false,
            },
            {
                label:'Year',
                field:'gl_year',
                fpFieldType:"integer",
                // type:'number',
                filterable: true,
                hidden:false,
            },
            {
                label:'Prd',
                field:'gl_period',
                fpFieldType:"integer",
                // type:'number',
                filterable: true,
                hidden:false,
            },
            {
                label:'Entity Number',
                field:'entity_no',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable: false
            },
            {
                label:'Entity Name',
                field:'entity_name',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable: false
            },
             {
                  label: 'Posted Date',
                  field: 'issued_at',
                  fpFieldType:"custom_date",
                  filterable: true,
                  hidden:false,
              },
              {
              label:'Posted Time',
              field:'posted_time',
              fpFieldType:"text",
              filterable: false,
              hidden:false,
              sortable:false
            },
            {
                label:'GL Reference',
                field:'reference',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Dist Comp',
                field:'dist_comp',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false,
            },

            {
                label:'Dist Flag',
                field:'dist_flag',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false,
            },
            {
                label:'Alternate Number',
                field:'alt_no',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false,
            },
            {
                label:'Fac',
                field:'location',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label:'Nat Acct',
                field:'natural_account',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Prod Line',
                field:'production_line',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Func Area',
                field:'function_area',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Debit Amount',
                field:'debit',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'Credit Amount',
                field:'credit',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'Account Type',
                field:'account_type',
                fpFieldType:"option",
                filterable: true,
                hidden:true,
            },
            {
                label:'Journal Entry Description',
                field:'jounal_entry_desc',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Settled',
                field:'is_settled',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Settled", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Yes','No'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },

            {
                label:'Batch',
                field:'batch',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },


        ],
        rows: [],
        totalRecords: 0,
        action:"list",
        showExportBtn:false,
        canCalculateEarnings:false,
        equityBatchProcess:0,
        equitybatchNum:"",
        batchId:0,
        batchError:false,
        batchErrorMsg:""
        // message:"Please Select Filters."
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'general_ledger_report') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'can_calculate_retained_earnings') {
                    self.canCalculateEarnings = true;
                }
            });
        }
    },
    created: function() {
        this.serverParams.sort = {field:"post_date",type:"desc"};
        this.serverParams.stopRequest = true;
    },
    mounted: function () {

        this.getPermissions();
        var self = this;

    },
    methods:{
        cancelAll: function (cancelAll) {
          this.$refs.glReport.unselectAllInternal();
        },
        loadList: function() {

            var self = this;

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action
            };
            if (self.action === "compare-with-enrich" || self.action === "compare-with-enrich_queue"){
              var filters = self.serverParams.columnFilters;
              var filterCounter = 0;
              for (let i = 0; i < filters.length; i ++){
                if (filters[i]['columnId'].field == "gl_year" || filters[i]['columnId'].field == "gl_period"){
                  filterCounter ++;
                }
              }
              if (filterCounter < 2){
                alert("For compare export, the data must be filtered with year and period values. Please filter your result with both year and period.");
                return;
              }
            }

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/general-ledger",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if ( self.action == "export" ||  self.action == "export_queue" || self.action == "compare-with-enrich" || self.action == "compare-with-enrich_queue" ) {

                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                if ( self.action == "export" || self.action == "compare-with-enrich") {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }

                            }

                            self.action = "list";
                            // self.loadList();
                            return;

                        } else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'general-ledger-report');
                }
            });
        },
        checkBatchStatus:function(){
            var self =  this;

            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.equityBatchProcess = false;
                        self.loadList();
                        sse.close();
                    }else if (data.status == "2") {
                        self.equityBatchProcess = false;
                        self.batchError = true;
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });

        },
        calculateEquity() {
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to Calculate Current R/E?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/general-ledger/recalculate-equity",
                        type: "POST",
                        data: {type:"monthly"},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.batch_id){
                                self.batchId = data.batch_id;
                                self.equitybatchNum = data.batch;
                                self.equityBatchProcess = true;
                                self.checkBatchStatus();
                            }

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'equity-recalculate')
                        }
                    });
                }else{

                }
            });
        },
        docLinkCreate(rowData) {
            var self = this;
            if (rowData.source != undefined && rowData.source != null && rowData.source != "") {
                if (rowData.doc_no != undefined && rowData.doc_no != null && rowData.doc_no != "") {
                    var fields = {
                        source:rowData.source,
                        doc_no:rowData.doc_no,
                        parent_module:rowData.parent_module,
                        module_name:rowData.module_name,
                        reference:rowData.reference,
                        parent_id:rowData.parent_id,
                        module_id:rowData.module_id,
                    };
                    self.loading = true;
                    $.ajax({
                        url:process.env.ROOT_API + "/doc-link/gl",
                        type:"POST",
                        data:fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success"){
                                if (data.content != ""){
                                    var linkData = document.createElement("a");
                                    linkData.href = data.content;
                                    linkData.target = "_blank";
                                    document.body.appendChild(linkData);
                                    linkData.click();
                                    document.body.removeChild(linkData);
                                }else{
                                    self.$swal('',data.message,'info');
                                    return;
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'equity-recalculate')
                        }
                    });
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/accounting/reports/GeneralLedgerReport.vue